module.exports = __webpack_public_path__ + "images/emoji/stuck_out_tongue_closed_eyes.aee2d1946beff8365ad4.png";